import {SearchFacade} from "./searchFacade";
import {resolve} from "../../../container";
import {customElement, property, state} from "lit/decorators.js";
import {ScrollService} from "../../../common/scroll";
import {QueryParameters} from "../../../common/queryParameters";
import {UnLitElement} from "../../../common/elements";
import {DefaultSearchGroup, type SearchGroup} from "./searchGroup";
import {html, type TemplateResult} from "lit";
import {trackingButtonInteract} from "../../../tracking/trackingAttributes";
import {classMap} from "lit/directives/class-map.js";
import {TAB_QUERY_PARAMETER_NAME} from "./constants";

@customElement("eop-search-group-tab")
export class SearchGroupTab extends UnLitElement {

    @property()
    private group: DefaultSearchGroup;
    @state()
    private newCount: number = 0;
    @state()
    private active: boolean = false;
    @state()
    private hasResults: boolean = false;

    public constructor(
        private searchFacade: SearchFacade = resolve(SearchFacade),
        private scrollService: ScrollService = resolve(ScrollService),
        private queryParameters: QueryParameters = resolve(QueryParameters)
    ) {
        super();
    }

    public connectedCallback(): void {
        super.connectedCallback();
        this.addEventListener("click", () => this.activate());
        this.registerGroup(this.group);
    }

    public disconnectedCallback(): void {
        this.searchFacade.unregisterGroup(this.group);
        super.disconnectedCallback();
    }

    public render(): TemplateResult {
        return html`
            <div class="content-search-tab ${classMap({"active": this.active, "no-result": !this.hasResults})}">
                <button class="link content-search-tab-link"
                        ${trackingButtonInteract(this.group.name)}>${this.group.name}</button>
                <span class="counter-container ${classMap({visible: this.newCount > 0})}">
                    <span class="counter background background-secondary">${this.newCount}</span>
                </span>
            </div>
        `;
    }

    private registerGroup(group: SearchGroup): void {
        group.onActivation((active) => {
            if (active) {
                this.updateGroupName(group.name);
            }
            this.active = active;
        });
        group.onFocus(() => this.center());
        group.onNewData((entries, newCount) => {
            this.newCount = newCount;
            this.hasResults = entries.length > 0;
        });
    }

    private updateGroupName(name: string): void {
        this.queryParameters.set(TAB_QUERY_PARAMETER_NAME, name);
        this.center(200);
    }

    private center(duration: number = 0): void {
        void this.scrollService.scrollToElementHorizontallyCentered(this, duration);
    }

    private activate(): void {
        this.searchFacade.switchTo(this.group.name);
    }
}